module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mentor"
    }
  }, [_c('h1', [_vm._v("Mentor 介面")]), _vm._v(" "), _c('h3', [_vm._v("Mentor ID")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "請輸入 Mentor ID",
      "maxlength": 3
    },
    model: {
      value: (_vm.mentorId),
      callback: function($$v) {
        _vm.mentorId = $$v
      },
      expression: "mentorId"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("問題集")]), _vm._v(" "), _c('p', [_vm._v("若能提供幫助，可至專案位置回答")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [(_vm.mentorQuestions) ? _c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_vm._l((_vm.mentorQuestions), function(question) {
    return [_c('el-collapse-item', {
      attrs: {
        "title": '專案 #' + question.projectId + '　　問: ' + question.title,
        "name": question['.key']
      }
    }, [_c('div', [_vm._v(_vm._s(question.description))])])]
  })], 2)], 1) : _c('h4', [_vm._v("尚未收到問題")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d84fbe24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorView.vue
// module id = 982
// module chunks = 1